import { useEffect, useState } from 'react';

import { matchSorter } from 'match-sorter';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import PropTypes from 'prop-types';

//lib
import { BoxlabelOptions } from '@/lib/reports/reportOptions';

import Checkbox from '@/components/base/Checkbox';
// Components
import { DefaultSearchBox } from '@/components/composite/SearchBox/DefaultSearchBox';
import CompetitorsItem from '@/components/pages/reports/components/Items/Types/CompetitorsItem';

const CompetitorsItemCheckbox = ({ allItems, isSubmitting, checkValue, id, disabled }) => {
    const { t } = useTranslation('reports');

    if (!allItems?.length) {
        {
            BoxlabelOptions(t)[id].empty;
        }
    }

    return allItems.map((item, key) => (
        <div className="flex items-center space-x-3" key={key}>
            <CompetitorsItem item={item} className="flex-1" />

            <div className="ml-1">
                <Checkbox
                    id={item.id}
                    onChange={() => checkValue(item.id)}
                    checked={item?.selected ?? false}
                    disabled={isSubmitting || disabled}
                />
            </div>
        </div>
    ));
};

const CompetitorItemSearchKey = [{ threshold: matchSorter.rankings.CONTAINS, key: 'name' }];

const SearchBoxCompetitor = ({ list = [], onSetList, errors, isLoading = false, disabled }) => {
    const { t } = useTranslation();
    const [castData, setCastData] = useState([]);

    useEffect(() => {
        let newList = [];
        newList = list?.map((profile) => ({
            ...profile,
            avatar: profile?.external_api_data?.avatar,
            username: profile?.slug,
            name: profile?.external_api_data?.name,
            type: profile?.social_network_type,
            selected: profile?.selected
        }));
        setCastData(newList);
    }, [list]);

    const onSetValues = (values) => {
        const updatedData = castData.map(
            (entry) => values?.find((updatedEntry) => entry?.id === updatedEntry?.id) ?? entry
        );
        setCastData(updatedData);
        onSetList(values.filter((item) => item.selected));
    };

    return (
        <DefaultSearchBox
            onSetValues={onSetValues}
            mutateList={null}
            errorList={null}
            searchKeys={CompetitorItemSearchKey}
            id="competitor"
            list={castData}
            errors={errors}
            isLoading={isLoading}
            disabled={disabled}
            noChoicesMessage={t('reports:general.competitor_no_items')}>
            {({ isSubmitting, checkValue, choices, id, disabled }) => {
                return (
                    <CompetitorsItemCheckbox
                        allItems={choices}
                        isSubmitting={isSubmitting}
                        checkValue={checkValue}
                        id={id}
                        disabled={disabled}
                    />
                );
            }}
        </DefaultSearchBox>
    );
};

SearchBoxCompetitor.propTypes = {
    onSetList: PropTypes.func.isRequired,
    list: PropTypes.array.isRequired,
    errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    isLoading: PropTypes.bool,
    disabled: PropTypes.bool
};

export default SearchBoxCompetitor;
